import { POStatus } from "./PurchaseOrder";
export enum VerifyStatus {
    Pending = 1,
    Not_Worked = 2,
    Rejected = 3,
    Verified = 4,
    UnVerified = 5,
    Complete = 6,
}
export interface ITimesheet {
    timesheet_ID?: number,
    pO_ID?: number,
    start_Date?: Date,
    consultant_ID?: number,
    fromDate?: Date,
    toDate?: Date,
    workHours?: string,
    overlapWorkHours?: number,
    addedBy?: string,
    editedBy?: string,
    verifiedBy?: string,
    timeSheet_Path?: string,
    consultant_Name?: string,
    timeSheet_Status?: string,
    comments?: string,
    verify_Status?: VerifyStatus,
    verify_Comment?: string,
    client?: string,
    end_Client?: string,
    vendor?: string,
    end_Date?: Date,
    pO_Status?: POStatus,
    isNotWorking?: boolean,
}